import React from 'react';

// @ts-ignore
import Icon from 'assets/images/trojanSvg/trap-icon-caught.svg';

const SnapTrapStatus_0: React.FC = () => {
  return <img src={Icon} height={28} alt="Snap Status 0 Icon" />;
};

export default SnapTrapStatus_0;
